import { CrosswordsGame } from "../../components/games/crossword/Crossword"

import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"

import { useSteps } from "../../hooks/useSteps"
import { useState } from "react"
import { ModalGanaste } from "../../components/games/ModalGanaste"
import { ElegirTag } from "../../components/games/ElegirTag"
import { GoBackBtn } from "../../components/games/GoBackBtn"
import useFetch from "../../hooks/useFetch"
import { config } from "../../config"
import { useParams } from "react-router"
import { api } from "../../services/api"
import { ModalError } from "../../components/ui/modal/ModalError"
import { ElegirMode } from "../../components/games/ElegirMode"
import { Breadcrumb } from "../../components/ui/Breadcrumb"
import { useTranslation } from "react-i18next"
import { tamanos } from "../../services/statics"

const ElegirDificultad = ({ setTamano }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="title">{t(`ui.games.headers.choose_puzzle_size`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="row">
          {tamanos.slice(0, -1).map((tam, ix) => (
            <div key={ix} className="col-lg-4 col-6 py-1">
              <div className="box category" onClick={() => setTamano(tam)}>
                <span>
                  {tam}x{tam}
                </span>
                <span>
                  <b>{t(`ui.games.sizes.${tam}`)}</b>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

const CrosswordsID = ({ uid }) => {
  const [data, isPending, err] = useFetch({
    url: `${config.apiUrl}/games/${uid}`,
  })

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    }

  const showErr = useState(true)

  const { t } = useTranslation()

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t(`ui.games.msgs.loading`)}...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <>
      <ModalGanaste show={showModalGanaste} />
      {data && (
        <CrosswordsGame
          data={data.entries}
          size={data.size}
          winCallback={handleWin}
        />
      )}
    </>
  )
}

const CrosswordsLoader = ({ size, tag, winCallback }) => {
  const [data, isPending, err] = useFetch({
    url: `${config.apiUrl}/games/crosswords/generate?tag=${tag}&size=${size}`,
  })

  const showErr = useState(true)

  const { t } = useTranslation()

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>{t(`ui.games.msgs.loading`)}...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <CrosswordsGame
      tag={tag}
      data={data}
      size={size}
      winCallback={winCallback}
    />
  )
}

const RandomCrosswordPicker = () => {
  let [steps] = useSteps(["mode", "tag", "tamano"]),
    setMode = steps.setter("mode"),
    setTag = steps.setter("tag"),
    setTamano = steps.setter("tamano")

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    },
    alAzarCallback = () => {
      const { url, opt } = api.tags.readAll({})
      fetch(url, opt)
        .then((res) => res.json())
        .then((data) => {
          let rTag =
            data.entries[Math.floor(Math.random() * data.entries.length)]
          // notar que lo lleno en orden reverso
          setTamano(8)
          setTag(rTag.name)
          setMode("random")
        })
    }

  const { t } = useTranslation()

  return (
    <>
      <ModalGanaste show={showModalGanaste} steps={steps} />

      <GoBackBtn steps={steps} />

      {steps.at("mode") && (
        <ElegirMode
          title={t(`games.crossword.title`)}
          setMode={setMode}
          alAzarCallback={alAzarCallback}
        />
      )}

      {steps.at("tag") && <ElegirTag setTag={setTag} />}

      {steps.at("tamano") && <ElegirDificultad setTamano={setTamano} />}

      {steps.done && (
        <CrosswordsLoader
          tag={steps.data.tag}
          size={steps.data.tamano}
          winCallback={handleWin}
        />
      )}

      {steps.done && (
        <div className="d-flex flex-row justify-content-center my-4">
          <Breadcrumb
            entries={[
              "Crosswords",
              steps.data.tag,
              `${steps.data.tamano}x${steps.data.tamano}`,
            ]}
          />
        </div>
      )}
    </>
  )
}

const CrosswordView = () => {
  const { uid } = useParams()

  return (
    <Container>
      {uid ? <CrosswordsID uid={uid} /> : <RandomCrosswordPicker />}
    </Container>
  )
}

export default CrosswordView
